module.exports = __webpack_public_path__ + "static/img/bay.b60cc651.svg";